exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".error_tip[data-v-598ab3bc]{position:absolute;top:0px;right:0px;-webkit-transform:translate(150%, 0px);transform:translate(150%, 0px);font-size:24px}.promoter_person .el-dialog__body[data-v-598ab3bc]{padding:10px 20px 14px 20px}.selected_list[data-v-598ab3bc]{margin-bottom:20px;line-height:30px}.selected_list span[data-v-598ab3bc]{margin-right:10px;padding:3px 6px 3px 9px;line-height:12px;white-space:nowrap;border-radius:2px;border:1px solid #dcdcdc}.selected_list img[data-v-598ab3bc]{margin-left:5px;width:7px;height:7px;cursor:pointer}\n", ""]);

// exports
